import { Role } from '@/models/AccountEnums';

export function normalizeRole<T extends string | undefined>(role: T): T | Role {
  return role === 'Team Member' ? Role.TeamMember : role;
}

export function normalizeRoles(
  roles: readonly Role[] | undefined,
): Role[] | undefined {
  return roles?.map((role) => normalizeRole(role));
}
